(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recruiting-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (customElements.get('wendt-careers')) return;

  const MAX_AGE = 30 * 60 * 1000;
  const EVENT = 'wendt:application_submitted';

  class WendtCareers extends HTMLElement {
    read(key) {
      try {
        const value = JSON.parse(sessionStorage.getItem(key) || 'null');

        if (
          !value ||
          !Number.isFinite(value.time) ||
          Date.now() - value.time > MAX_AGE ||
          value.time > Date.now() + 60000
        ) {
          sessionStorage.removeItem(key);
          return null;
        }

        return value;
      } catch (_) {
        return null;
      }
    }

    write(key, value) {
      try {
        sessionStorage.setItem(key, JSON.stringify(value));
      } catch (_) {}
    }

    remove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (_) {}
    }

    connectedCallback() {
      if (this.controller || this.dataset.wdView !== 'application') return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.draftKey = 'wendt-recruiting:v3:draft:' + location.pathname;
      this.pendingKey = 'wendt-recruiting:v3:pending:' + location.pathname;

      const success = this.querySelector('[data-wd-success]');

      if (success) {
        this.remove(this.draftKey);

        const pending = this.read(this.pendingKey);
        this.remove(this.pendingKey);

        success.focus({ preventScroll: true });

        if (
          pending &&
          pending.mode === 'service' &&
          typeof pending.id === 'string' &&
          this.dataset.wdTrack === 'true' &&
          this.dataset.wdDesignMode !== 'true'
        ) {
          this.confirmed = {
            application_id: pending.id,
            application_type: 'service'
          };

          this.delivered = {};
          this.startTracking(options);
        }

        return;
      }

      this.form = this.querySelector('.wd-form');
      if (!this.form) return;

      this.allSteps = [
        ...this.form.querySelectorAll('[data-wd-step]')
      ];

      this.fields = [
        ...this.form.querySelectorAll('input, textarea, select')
      ].filter(field =>
        field.name.startsWith('contact[') &&
        field.type !== 'hidden' &&
        !field.hidden
      );

      this.form.noValidate = true;
      this.classList.add('is-enhanced');

      this.querySelector('[data-wd-progress]').hidden = false;
      this.querySelector('[data-wd-navigation]').hidden = false;

      const draft = this.read(this.draftKey);
      this.restore(draft);

      this.setMode();

      const startIndex = this.querySelector('[data-wd-server-error]')
        ? this.steps.length - 1
        : (
          draft?.mode === this.mode && Number.isInteger(draft.index)
            ? draft.index
            : 0
        );

      this.show(startIndex, false);

      if (this.querySelector('[data-wd-server-error]')) {
        this.remove(this.pendingKey);

        this.querySelector('[data-wd-server-error]').focus({
          preventScroll: true
        });
      }

      this.querySelector('[data-wd-next]').addEventListener(
        'click',
        () => {
          if (this.validateStep(this.index, true)) {
            this.show(this.index + 1, true);
          }
        },
        options
      );

      this.querySelector('[data-wd-back]').addEventListener(
        'click',
        () => this.show(this.index - 1, true),
        options
      );

      this.form.addEventListener(
        'input',
        event => this.onInput(event),
        options
      );

      this.form.addEventListener(
        'change',
        event => this.onChange(event),
        options
      );

      this.form.addEventListener(
        'keydown',
        event => {
          if (
            event.key !== 'Enter' ||
            !(event.target instanceof HTMLInputElement)
          ) {
            return;
          }

          if (this.index < this.steps.length - 1) {
            event.preventDefault();

            if (this.validateStep(this.index, true)) {
              this.show(this.index + 1, true);
            }
          }
        },
        options
      );

      this.form.addEventListener(
        'submit',
        event => this.submit(event),
        options
      );

      window.addEventListener(
        'pagehide',
        () => this.saveDraft(),
        options
      );

      window.addEventListener(
        'pageshow',
        () => this.resetSubmit(),
        options
      );
    }

    setMode() {
      this.mode = 'service';

      this.allSteps.forEach(step => {
        step.disabled = false;
        step.hidden = false;
      });

      this.steps = this.allSteps;

      this.form.querySelector('[data-wd-role]').value = this.dataset.wdJob;
      this.form.querySelector('[data-wd-application-type]').value =
        'Stellenbewerbung';

      const subtitle = this.querySelector('[data-wd-subtitle]');
      subtitle.replaceChildren();

      const job = this.dataset.wdJob || '';
      const position = job.indexOf('Servicetechniker');

      if (position === -1) {
        subtitle.textContent = job;
      } else {
        const bold = document.createElement('strong');
        bold.textContent = 'Servicetechniker';

        subtitle.append(
          document.createTextNode(job.slice(0, position)),
          bold,
          document.createTextNode(
            job.slice(position + 'Servicetechniker'.length)
          )
        );
      }
    }

    restore(draft) {
      if (!Array.isArray(draft?.fields)) return;

      this.fields.forEach(field => {
        const choice =
          field.type === 'radio' || field.type === 'checkbox';

        const saved = draft.fields.find(item =>
          item.name === field.name &&
          (!choice || item.value === field.value)
        );

        if (!saved || typeof saved.value !== 'string') return;

        if (choice) {
          field.checked = saved.checked === true;
        } else {
          field.value = saved.value.slice(
            0,
            field.maxLength > 0 ? field.maxLength : 2000
          );
        }
      });
    }

    saveDraft() {
      if (!this.form || !this.fields || !this.mode) return;

      this.write(this.draftKey, {
        time: Date.now(),
        mode: this.mode,
        index: this.index || 0,
        fields: this.fields.map(field => ({
          name: field.name,
          value: field.value,
          checked: field.checked === true
        }))
      });
    }

    onInput(event) {
      const input = event.target;

      if (
        !(
          input instanceof HTMLInputElement ||
          input instanceof HTMLTextAreaElement
        )
      ) {
        return;
      }

      input.removeAttribute('aria-invalid');

      const error = input
        .closest('.wd-field')
        ?.querySelector('[data-wd-field-error]');

      if (error) error.hidden = true;

      this.querySelector('[data-wd-feedback]').hidden = true;

      clearTimeout(this.draftTimer);
      this.draftTimer = setTimeout(() => this.saveDraft(), 250);
    }

    onChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      const group = input.closest('[data-wd-experience]');

      if (group && input.checked) {
        if (input.hasAttribute('data-wd-none')) {
          group
            .querySelectorAll('input:not([data-wd-none])')
            .forEach(item => {
              item.checked = false;
            });
        } else {
          group.querySelector('[data-wd-none]').checked = false;
        }
      }

      const step = input.closest('[data-wd-step]');

      if (step) {
        step
          .querySelectorAll('input[aria-invalid]')
          .forEach(item => item.removeAttribute('aria-invalid'));

        const error = step.querySelector('[data-wd-step-error]');
        if (error) error.hidden = true;
      }

      this.saveDraft();
    }

    fieldMessage(input) {
      const value = input.value.trim();

      if (input.name === 'contact[name]') {
        return value
          ? ''
          : 'Bitte gib deinen Vor- und Nachnamen ein.';
      }

      if (input.name === 'contact[email]') {
        if (!value) return 'Bitte gib deine E-Mail-Adresse ein.';

        return input.validity.typeMismatch
          ? 'Bitte gib eine gültige E-Mail-Adresse ein.'
          : '';
      }

      if (input.name === 'contact[phone]') {
        if (!value) return 'Bitte gib deine Telefonnummer ein.';

        const digits = value.replace(/\D/g, '').length;

        return (
          digits >= 6 &&
          digits <= 20 &&
          /^\+?[\d\s().\/-]+$/.test(value)
        )
          ? ''
          : 'Bitte gib eine gültige Telefonnummer mit Vorwahl ein.';
      }

      return '';
    }

    validateStep(index, focus) {
      const step = this.steps[index];
      let first = null;

      const groupError = step.querySelector('[data-wd-step-error]');

      if (groupError) {
        const valid = Boolean(step.querySelector('input:checked'));

        step.querySelectorAll('input').forEach(input => {
          if (valid) {
            input.removeAttribute('aria-invalid');
          } else {
            input.setAttribute('aria-invalid', 'true');
          }
        });

        groupError.textContent = step.hasAttribute('data-wd-experience')
          ? 'Bitte wähle mindestens eine Antwort aus.'
          : 'Bitte wähle eine Antwort aus.';

        groupError.hidden = valid;

        if (!valid) first = step.querySelector('input');
      }

      step
        .querySelectorAll('.wd-field input[required]')
        .forEach(input => {
          const message = this.fieldMessage(input);

          const error = input
            .closest('.wd-field')
            .querySelector('[data-wd-field-error]');

          if (message) {
            input.setAttribute('aria-invalid', 'true');
            error.textContent = message;
            error.hidden = false;
            first = first || input;
          } else {
            input.removeAttribute('aria-invalid');
            error.hidden = true;
          }
        });

      if (focus && first) first.focus();

      return !first;
    }

    firstInvalid() {
      return this.steps.findIndex(
        (_, index) => !this.validateStep(index, false)
      );
    }

    show(index, focus) {
      this.index = Math.max(
        0,
        Math.min(index, this.steps.length - 1)
      );

      this.allSteps.forEach(step => {
        step.hidden = true;
      });

      this.steps[this.index].hidden = false;

      this.querySelector('[data-wd-count]').textContent =
        'Schritt ' + (this.index + 1) + ' von ' + this.steps.length;

      this.querySelector('[data-wd-progress-fill]').style.width =
        ((this.index + 1) / this.steps.length * 100) + '%';

      this.querySelector('[data-wd-back]').hidden =
        this.index === 0;

      this.querySelector('[data-wd-next]').hidden =
        this.index === this.steps.length - 1;

      this.saveDraft();

      if (focus) {
        const legend = this.steps[this.index].querySelector('legend');
        legend.tabIndex = -1;
        legend.focus({ preventScroll: true });

        const shell = this.querySelector('.wd-form-shell');

        if (shell.getBoundingClientRect().top < 20) {
          shell.scrollIntoView({
            block: 'start',
            behavior: 'auto'
          });
        }
      }
    }

    bodyText() {
      const lines = [
        'Kurzbewerbung bei Wendt Dental Service',
        'Stelle: ' + this.form.querySelector('[data-wd-role]').value
      ];

      this.steps.forEach(step => {
        const answers = [
          ...step.querySelectorAll('input:checked')
        ].map(input => input.value);

        if (answers.length) {
          lines.push(
            step.querySelector('legend').textContent.trim() +
            '\n' +
            answers.join(', ')
          );
        }
      });

      const labels = [
        ['contact[name]', 'Name'],
        ['contact[email]', 'E-Mail'],
        ['contact[phone]', 'Telefon'],
        ['contact[Erreichbarkeit]', 'Am besten erreichbar']
      ];

      labels.forEach(([name, label]) => {
        const value = this.form.elements.namedItem(name).value.trim();
        if (value) lines.push(label + ': ' + value);
      });

      return lines.join('\n\n');
    }

    submit(event) {
      if (this.submitting) {
        event.preventDefault();
        return;
      }

      const invalid = this.firstInvalid();

      if (invalid !== -1) {
        event.preventDefault();
        this.show(invalid, false);
        this.validateStep(invalid, true);
        return;
      }

      if (navigator.onLine === false) {
        event.preventDefault();
        this.saveDraft();

        this.feedback(
          'Du bist gerade offline. Deine Angaben bleiben erhalten. ' +
          'Bitte stelle die Verbindung wieder her und sende die Bewerbung erneut.'
        );

        return;
      }

      this.fields
        .filter(field =>
          field.type !== 'radio' &&
          field.type !== 'checkbox'
        )
        .forEach(field => {
          field.value = field.value.trim();
        });

      this.form.querySelector('[name="contact[body]"]').value =
        this.bodyText();

      this.saveDraft();

      const pending = this.read(this.pendingKey);

      const id = pending?.id || (
        typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : Date.now().toString(36) +
            Math.random().toString(36).slice(2)
      );

      this.write(this.pendingKey, {
        time: Date.now(),
        id,
        mode: this.mode
      });

      // Shopify kann den ersten Submit für seine Sicherheitsabfrage anhalten.
      // Erst nach allen Submit-Listenern sperren.
      clearTimeout(this.lockTimer);

      this.lockTimer = setTimeout(() => {
        if (event.defaultPrevented || !this.isConnected) return;

        this.submitting = true;

        const button = this.querySelector('[data-wd-submit]');
        button.disabled = true;
        button.textContent = 'Wird gesendet';

        this.form.setAttribute('aria-busy', 'true');

        this.submitTimer = setTimeout(() => {
          this.resetSubmit();

          this.feedback(
            'Die Übermittlung wurde hier noch nicht bestätigt. ' +
            'Deine Angaben bleiben erhalten. ' +
            'Bitte prüfe die Seite und versuche es bei Bedarf erneut.'
          );
        }, 30000);
      }, 0);

      // Shopify verarbeitet den nativen POST.
    }

    feedback(text) {
      const element = this.querySelector('[data-wd-feedback]');
      element.textContent = text;
      element.hidden = false;
      element.focus({ preventScroll: true });
    }

    resetSubmit() {
      clearTimeout(this.submitTimer);
      this.submitting = false;

      const button = this.querySelector('[data-wd-submit]');
      if (!button) return;

      button.disabled = false;
      button.textContent = 'Bewerbung senden';
      this.form.removeAttribute('aria-busy');
    }

    startTracking(options) {
      const attempt = () => this.emitConversion();

      document.addEventListener(
        'visitorConsentCollected',
        attempt,
        options
      );

      window.addEventListener('load', attempt, options);

      if (
        !window.Shopify?.customerPrivacy &&
        typeof window.Shopify?.loadFeatures === 'function'
      ) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          error => {
            if (!error && this.isConnected) attempt();
          }
        );
      }

      attempt();

      this.trackingTimers = [1000, 3000, 8000].map(
        delay => setTimeout(attempt, delay)
      );
    }

    emitConversion() {
      const privacy = window.Shopify?.customerPrivacy;

      if (
        !this.confirmed ||
        typeof privacy?.analyticsProcessingAllowed !== 'function' ||
        privacy.analyticsProcessingAllowed() !== true
      ) {
        return;
      }

      if (
        !this.delivered.shopify &&
        !this.publishing &&
        typeof window.Shopify?.analytics?.publish === 'function'
      ) {
        this.publishing = true;

        try {
          Promise.resolve(
            window.Shopify.analytics.publish(EVENT, {
              ...this.confirmed
            })
          )
            .then(result => {
              if (result !== false) {
                this.delivered.shopify = true;
              }
            })
            .catch(() => {})
            .finally(() => {
              this.publishing = false;
            });
        } catch (_) {
          this.publishing = false;
        }
      }

      if (
        !this.delivered.gtm &&
        Array.isArray(window.dataLayer)
      ) {
        window.dataLayer.push({
          event: 'wendt_application_submitted',
          ...this.confirmed
        });

        this.delivered.gtm = true;
      }
    }

    disconnectedCallback() {
      clearTimeout(this.draftTimer);
      clearTimeout(this.lockTimer);
      clearTimeout(this.submitTimer);

      this.trackingTimers?.forEach(clearTimeout);
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('wendt-careers', WendtCareers);
})();

  } catch(e) { console.error(e); }
})();
})();
